import { useState } from "react";
import { Button, Col, Flex } from "antd";
import dayjs from "dayjs";
import styles from "../../deliveryServices/DeliveryServices.module.css";
import useStore from "../../../hooks/useStore";
import postOnboardForm from "../../apiRepository/postOnboardForm";
import GrubhubConnectCard from "./GrubHubConnectCard";

export default function GrubHubNotice({ handleShowForm, handleBack, handleNotification }) {
  const { store } = useStore();
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseSnackbar2 = () => {
    setIsLoading(false);
    handleBack();
  };

  const handlePostOnboarding = async () => {
    const data = {
      salesTax: store.salesTax || store.taxRate || store.formData.taxRate,
      firstName: store.formData?.contactFirstName,
      lastName: store.formData?.contactLastName,
      sensitiveData: {
        routingNumber: store.formData?.routingNumber,
        bankAccountNumber: store.formData?.bankAccountNumber,
        ein: store.formData?.ein,
        ssn: store.formData?.ssn,
        legalBusinessName: store.formData?.legalBusinessName,
        legalDOB: dayjs(store.formData?.legalDOB).format("MM/DD/YYYY"),
        legalEmail: store.formData?.legalEmail || store.email,
        typeOfEntity: store.formData?.typeOfEntity
      }
    };
    const res = await postOnboardForm({
      token: store?.token,
      integratorId: store?.integratorId,
      storeId: store?.storeId,
      deliveryService: "GRUBHUB",
      isExisting: false,
      data,
    });

    return res;
  };

  const submit = async () => {
    try {
      setIsLoading(true);

      // Send api request and redirect to generated link
      const res = await handlePostOnboarding();
      window.open(res.data.link);

      setIsLoading(false);
      handleCloseSnackbar2();
      handleNotification();
    } catch (err) {
      // Display form if error
      handleShowForm();
    }
  };

  return (
    <GrubhubConnectCard>
      <Col align="start">
        <p className={styles.dsFormLabels}>
          Please take pictures of the following documents with your device
          before starting your Grubhub application:
        </p>
        <ul className={styles.dsFormLabels} style={{ paddingLeft: "15px" }}>
          <li>Completed W-9</li>
          <li>Liqour License</li>
          <li>Voided Check</li>
        </ul>
        <br />
        <Flex gap="small" wrap>
          <Button
            type="primary"
            block
            className={styles.dsLargeButton}
            disabled={isLoading}
            loading={isLoading}
            onClick={submit}
          >
            <p>{isLoading ? "Please Wait..." : "PROCEED"}</p>
          </Button>
          <Button
            variant="outlined"
            block
            danger
            disabled={isLoading}
            className={styles.dsLargeButton}
            onClick={handleBack}
          >
            <p>CANCEL</p>
          </Button>
        </Flex>
      </Col>
    </GrubhubConnectCard >
  );
}
